import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QueryVcsIntegrationTestArgs,
  VcsIntegration,
  VcsIntegrationTestResult,
} from "types/generated";

import { vcsIntegrationDetailsFragment } from "../VcsShared/gql";

type FetchVCSIntegrationData = {
  vcsIntegration: Omit<VcsIntegration, "createdAt" | "searchUsers">;
};

export const GET_VCS_INTEGRATION: TypedDocumentNode<FetchVCSIntegrationData> = gql`
  ${vcsIntegrationDetailsFragment}
  query GetVcsIntegration(
    $id: ID!
    $provider: VCSProvider!
    $searchUsersSuggestionsInput: SearchSuggestionsInput!
  ) {
    vcsIntegration(id: $id, provider: $provider) {
      id
      name
      labels
      description
      provider
      updatedAt
      isDefault
      space {
        id
        name
        accessLevel
      }
      ...vcsIntegrationDetails
      searchUsersSuggestions(input: $searchUsersSuggestionsInput) {
        filteredCount
      }
    }
  }
`;

type SearchVCSIntegrationUsedByData = {
  vcsIntegration: Omit<VcsIntegration, "createdAt">;
};

export const SEARCH_VCS_INTEGRATION_USED_BY_V2: TypedDocumentNode<SearchVCSIntegrationUsedByData> = gql`
  query SearchVcsIntegrationUsedByV2(
    $id: ID!
    $provider: VCSProvider!
    $searchUsersInput: SearchInput!
    $searchUsersSuggestionsInput: SearchSuggestionsInput!
  ) {
    vcsIntegration(id: $id, provider: $provider) {
      id
      provider
      name
      searchUsers(input: $searchUsersInput) {
        edges {
          cursor
          node {
            stackName
            stackId
            isModule
            spaceDetails {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      searchUsersSuggestions(input: $searchUsersSuggestionsInput) {
        filteredCount
      }
    }
  }
`;

type TestVCSIntegrationData = {
  vcsIntegrationTest: VcsIntegrationTestResult;
};

export const TEST_VCS_INTEGRATION: TypedDocumentNode<
  TestVCSIntegrationData,
  QueryVcsIntegrationTestArgs
> = gql`
  query TestVcsIntegration($id: ID!, $provider: VCSProvider!) {
    vcsIntegrationTest(id: $id, provider: $provider) {
      checks {
        type
        status
        metadata {
          githubAppEvents
          permissions
          reason
          webHooks {
            actual
            expected
          }
        }
      }
      status
    }
  }
`;
